import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomButton, MobilePagination, Text } from '../../shared/uiComponents';
import { Loader } from '../../components/StyledComponents';
import MobileSort from '../../components/MobileSort';
import { AdminDataProperties } from './tableInfo';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getBTs } from '../../redux/State/userSlice';
import { SelectDataProperties } from '../../shared/uiComponents/Dropdown';
import { PlusIcon, SearchIcon } from '../../shared/Assets/svg';
import SearchBar from '../../components/SearchBar';
import MobileViewClientItem from '../../components/MobileViewClientItem';
import { PERMISSIONS } from '../../App/constants';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { AdminTypes } from '../../components/Menu';
import { Users } from '../../shared/Assets/menuIcons';

const sortData: SelectDataProperties[] = [
	{ id: 'fullName', name: 'Full Name' },
	{ id: 'numberOfClients', name: 'Number of Clients' },
	{ id: 'emailConfirmed', name: 'Email Status' },
	{ id: 'isDeactivated', name: 'Account Status' },
];

const MobileView: FC<AdminDataProperties> = (data) => {
	const { query, totalNumberOfItems } = data;
	const [params] = useSearchParams();
	const [searchOpen, setSearchOpen] = useState(false);

	const dispatch = useDispatch<DispatchProperties>();
	const loading = useSelector((state) => state.user.loading);
	const navigate = useNavigate();

	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);

	const fetchUsers = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';

		dispatch(getBTs({ page, pageSize, orderBy, direction, searchString }));
	};

	const addBtHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[2]);
		navigate('/bt/new');
	};

	return (
		<div className="mobileViewClientsContainer">
			<div className="mobileViewClientsContainerHeader">
				<div className="mobileViewClientsContainerTitle">
					<div className="mobileViewClientsContainerTitleIcon">
						<Users />
					</div>
					<Text title="BTs" type="pmd" fontWeight="semiBold" />
				</div>
				<div className="mobileViewClientsContainerActions">
					<CustomButton
						buttonType="secondaryGray"
						iconOnly={<SearchIcon size={20} />}
						onClick={() => setSearchOpen((v) => !v)}
					/>
					{permissionGranted && <CustomButton title="Add BT" iconOnly={<PlusIcon />} onClick={addBtHandler} />}
				</div>
			</div>
			<div className={`mobileViewClientsContainerSearchExpander ${searchOpen ? 'open' : ''}`}>
				<SearchBar style={{ marginTop: 8 }} />
			</div>
			<MobileSort data={sortData} />
			{loading && <Loader />}
			{!loading && !totalNumberOfItems && (
				<div className="mobileViewClientsContainer">
					<Text title="No results" type="plg" fontWeight="semiBold" className="marginAuto" />
				</div>
			)}
			{!loading && query?.map((item) => <MobileViewClientItem data={item} fetchUsers={fetchUsers} key={item.id} />)}
			<MobilePagination data={data} />
		</div>
	);
};

export default MobileView;
